// ── Compliance assignment status labels (Sprint H, ED-SH-4) ──────────────────
// Human-readable strings for unified 8-state lifecycle.
// Internal enum values stay snake_case; display strings use sentence case.

import type { AssignmentState } from '@grc/shared';

export const STATUS_LABELS: Record<AssignmentState, string> = {
  unassigned:           'Not assigned',
  assigned:             'Assigned',
  in_progress:          'In progress',
  submitted:            'Submitted for review',
  sent_back:            'Sent back',
  implemented:          'Implemented',
  compensating_control: 'Compensating control',
  not_applicable:       'Not applicable',
};
